import React from "react";
import { MapWithAMarker } from "./map/GoogleMap";
import Avatar from "@material-ui/core/Avatar";

import { Helmet } from "react-helmet";

import ProfileImg from "../../assets/images/Profile/76298_1510519641231_5582148_n.jpg";

// import { FacebookProvider, Group, Profile } from "react-facebook";

const Conatacts = () => {
  return (
    <div id="contacts">
      <Helmet>
        <meta charSet="utf-8" />
        <link rel="shortcut icon" type="image/png" href="/public/Icon.png" />
        <title>Планета Рыбака - Контакты</title>
        <link rel="canonical" href="https://rybalka-md.com" />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta
          name="description"
          content="Магазин рыболовных изделий в Молдове, Кишинёв, улица Alba-Iulia 198 ger.34/1, рынок 'Дельфин'. Тут вы найдёте удилища, кутушки, снасти, прикормки, наживки, приманки, подставки, подсаки, сумки, одежда, снаряжения и другое, всё для рыбалки."
        />
        <meta
          property="og:url"
          content="https://rybalka-md.com/contacts"
        />
      </Helmet>
      <h1 className="all_products_title" style={{ margin: "0" }}>
        Контакты
      </h1>
      <div className="container">
        <div className="contacts_wrapper">
          <div className="left">
            <div className="profile">
              <div className="avatar" style={{ textAlign: "center" }}>
                <Avatar
                  alt="Remy Sharp"
                  src={ProfileImg}
                  style={{
                    width: "40%",
                    height: "40%",
                    margin: "0 auto"
                  }}
                />
                <h4 className="name">Юрий Горняк</h4>
              </div>

              <div className="contact_number">+373 69 90 27 86</div>

              <div className="social_media">
                {/* <FacebookProvider appId="123456789">
                  <Group
                    href="https://www.facebook.com/groups/1735631426741689/"
                    width="300"
                    height="300"
                    showSocialContext={true}
                    showMetaData={true}
                    skin="light"
                    style={{
                      height: "200px"
                    }}
                  />
                </FacebookProvider> */}
                <div
                  className="fb-group"
                  data-href="https://www.facebook.com/groups/1735631426741689/"
                  data-width="300"
                  data-show-social-context="true"
                  data-show-metadata="false"
                />
              </div>
            </div>
          </div>

          <div className="right" style={{ color: " #005f9c" }}>
            <div className="info">
              <div className="city" style={{ display: "flex" }}>
                <i className="fas fa-city" />
                <div>Кишинёв</div>
              </div>

              <div className="shop" style={{ display: "flex" }}>
                <i className="fas fa-map-marked-alt" />
                <div>Alba-Iulia 198 ger. 34/1</div>
              </div>

              <div className="shop" style={{ display: "flex" }}>
                <i className="fas fa-phone" />
                <div>069902786</div>
              </div>
            </div>
            <div className="map">
              <MapWithAMarker
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCEOhxE5P81cojweIcw6PD-XHmrYIrXVaU&v=3.exp&libraries=geometry,drawing,places"
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `400px` }} />}
                mapElement={<div style={{ height: `100%` }} />}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Conatacts;
